import { render } from "./modalReceptBook.vue?vue&type=template&id=3cf2a4e2"
import script from "./modalReceptBook.vue?vue&type=script&lang=js"
export * from "./modalReceptBook.vue?vue&type=script&lang=js"

import "./modalReceptBook.vue?vue&type=style&index=0&id=3cf2a4e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__